import React from "react"
import { Option } from "fp-ts/Option"
import { FareCardBase, FareCardFooter } from "@silversea-ssc/ui-components-react"
import { FareInfographicBoxStatus } from "../../../../components/FareInfographicBox/FareInfographicBox"
import { CruisePaymentTermsResponse } from "../../../_common/dot-com-api-types"
import { FareCard } from "../../_common/read-models/fare-card"
import { CardPromoBadgesContent, FareContent } from "../../../_common/sanity/sanity-types"
import { useECommerceMachine } from "../../../_common/machines/machines-context"
import { buildPromoBadgesContent } from "../../_common/promo-badges"
import InfographicExpandButton from "./Infographic/InfographicExpandButton"
import { computeVenetianSocietyStatus } from "./helpers"
import { FarePriceHeader } from "./Infographic/FarePriceHeader"
import { FarePriceFooter } from "./Infographic/FarePriceFooter"
import styles from "./FarePrice.module.scss"

type Props = {
    fareCard: FareCard
    paymentTerms: Option<CruisePaymentTermsResponse>
    status: FareInfographicBoxStatus
    promoBadgesContent: CardPromoBadgesContent[]
    fareContent: FareContent
}

const FarePriceLoading: React.FC<React.PropsWithChildren<Props>> = ({
    status,
    paymentTerms,
    fareCard,
    promoBadgesContent,
    fareContent,
}) => {
    const [state] = useECommerceMachine()

    const venetianSocietyStatus = computeVenetianSocietyStatus(fareCard.vsEligibility, state.context.vsCode)
    const promoBadges = buildPromoBadgesContent(fareCard.options.promotions, promoBadgesContent)

    return (
        <FareCardBase fullHeight={false} trackingName={`fare_infographic_box`} className={styles.fareCards}>
            <FarePriceHeader
                fareContent={fareContent}
                fareTitle={fareContent.title}
                paymentTerms={paymentTerms}
                fareCode={fareCard.fare}
            />
            <FareCardFooter padding="small">
                <FarePriceFooter
                    status={status}
                    fareCard={fareCard}
                    venetianSocietyStatus={venetianSocietyStatus}
                    promoBadges={promoBadges}
                    farePriceResponseState={{ type: "loading" }}
                    faresAreLoading={state.matches("flow.nothingSelected.fareUnselectable")}
                />
            </FareCardFooter>
            <InfographicExpandButton isExpanded={false} />
        </FareCardBase>
    )
}

export default FarePriceLoading
